import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminAuthAPI } from '../../lib/adminApi';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Phone, ArrowRight, Loader2, Shield } from 'lucide-react';

export default function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await adminAuthAPI.login({ email, password });
      localStorage.setItem('dotcall_admin_token', res.data.token);
      localStorage.setItem('dotcall_admin', JSON.stringify(res.data.admin));
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: '#020617' }} data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2.5 mb-6">
            <div className="w-10 h-10 rounded-lg bg-amber-600 flex items-center justify-center">
              <Phone className="w-5 h-5 text-white" />
            </div>
            <span className="text-2xl font-bold font-['Outfit'] text-white">DotCall</span>
          </div>
          <div className="flex items-center justify-center gap-2 mb-3">
            <Shield className="w-5 h-5 text-amber-400" />
            <h2 className="text-2xl font-bold font-['Outfit'] text-white">Admin Panel</h2>
          </div>
          <p className="text-slate-400 text-sm">Super Admin access only</p>
        </div>

        {error && (
          <div className="mb-6 p-3 rounded-lg bg-red-500/10 border border-red-500/20 text-red-400 text-sm" data-testid="admin-login-error">
            {error}
          </div>
        )}

        <div className="glass-card rounded-xl p-6">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label className="text-slate-300 text-sm mb-2 block">Admin Email</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@dotcall.ai"
                required
                data-testid="admin-email-input"
                className="bg-slate-950 border-white/10 focus:border-amber-500/50 h-11 text-white placeholder:text-slate-600"
              />
            </div>
            <div>
              <Label className="text-slate-300 text-sm mb-2 block">Password</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter admin password"
                required
                data-testid="admin-password-input"
                className="bg-slate-950 border-white/10 focus:border-amber-500/50 h-11 text-white placeholder:text-slate-600"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              data-testid="admin-login-button"
              className="w-full h-11 bg-amber-600 hover:bg-amber-700 text-white font-medium shadow-[0_0_20px_rgba(245,158,11,0.3)]"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <>Sign In <ArrowRight className="w-4 h-4 ml-2" /></>}
            </Button>
          </form>
        </div>

        <p className="text-center text-slate-600 mt-6 text-xs">
          Protected area. Unauthorized access is prohibited.
        </p>
      </div>
    </div>
  );
}
